var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import { Tag } from '@/models/Tag';
let AddTagDialog = class AddTagDialog extends Vue {
    constructor() {
        super(...arguments);
        this.tag = new Tag();
        this.modal = false;
    }
    mounted() { }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    create() {
        this.tag
            .create()
            .then((tag) => {
            this.$emit('tagCreated');
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    clear() {
        this.tag = new Tag();
    }
};
AddTagDialog = __decorate([
    Component({
        components: {},
    })
], AddTagDialog);
export default AddTagDialog;
